export default __webpack_public_path__ + "static/AkebiaCares-logo-d87997cb054961a0b5375ffa55a523ad.png";